'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function isEmpty() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var isNumber = typeof value === 'number';
  var isBool = typeof value === 'boolean';

  if (Array.isArray(value)) {
    return !value.length;
  }

  if (isBool) {
    return !value;
  }

  return isNumber ? false : !value || !value.trim().length;
}

exports.default = isEmpty;
//# sourceMappingURL=isEmpty.js.map
